module.exports = __webpack_public_path__ + "img/eye.07592523.png";